import React from 'react'

import PeerInviteForm from 'app/domains/common/PeerInviteForm'
import IconButton from 'app/domains/common/IconButton'
import PeerInviteIcon from 'app/components/SVGS/PeerInviteIcon'
import { USER } from 'app/constants/roles'

import './styles.scss'

const bc = 'peer-invite-button'

const PeerInviteButton = ({ showModal, role, t }) => {
  return role === USER ? (
    <React.Fragment>
      <IconButton className={bc} onClick={() => showModal(<PeerInviteForm />, { size: 'lg', important: true })}>
        <PeerInviteIcon />
      </IconButton>
      <span className={`${bc}__text`}>{t('Click here to invite a friend or colleague')}</span>
    </React.Fragment>
  ) : null
}

export default PeerInviteButton
